module.exports = __webpack_public_path__ + "img/PDPA-3.ad4925e9.png";